export const FILE_PREVIEW_TELEMETRY_EVENT_NAME = {
    FilePreviewStarted: 'FilePreviewStarted',
    FilePreviewEnded: 'FilePreviewEnded',
};
